<!--
/**
* @name: GrantDetail.vue
* @description: 优惠券发放详情
* @author: 杨波
* @create: 2020/08/15 09:40:37
* @update: 2020/08/15 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false" @search="onSearch">
      <y-query-item>
        <k-select placeholder="请选择状态" clearable block v-model="para.status">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <y-button @click="onDownLoad()">下载优惠券码</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="dataList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="dataList && dataList.length > 0" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import { NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_PAGE, NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_EXPORT } from "@/assets/modules/apiList";
const initPara = () => ({
  bonusId: "",
  status: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      dataList: [],
      para: initPara(),
      statusList: [
        { value: "UN_CHANGE", label: "未领取" },
        { value: "UN_USE", label: "未使用" },
        { value: "USED", label: "已使用" },
      ],
      total: 0,
      isLoading: false,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "序号",
          field: "id",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "优惠券码",
          field: "code",
          style: {
            width: 120,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "领取人电话号码",
          field: "memberInfo",
          style: {
            textAlign: "center",
          },
          customRender:row=>(
            <insensitive val={row.memberInfo} isShowEye={false}></insensitive>
          )
        },
        {
          name: "微店ID",
          field: "microShopId",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "门店名称",
          field: "clientName",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "订单编号",
          field: "usedOrderNo",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "状态",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => {
            if (row.status == "UN_USE") {
              return (
                <div>
                  <span class={this.css.default_style}></span>
                  <span>未使用</span>
                </div>
              );
            } else if (row.status == "UN_CHANGE") {
              return (
                <div>
                  <span class={this.css.default_style}></span>
                  <span>未领取</span>
                </div>
              );
            } else if (row.status == "USED") {
              return (
                <div>
                  <span class={this.css.used_style}></span>
                  <span>已使用</span>
                </div>
              );
            } else if (row.status == "EXPIRED") {
              return (
                <div>
                  <span class={this.css.repire_style}></span>
                  <span>已过期</span>
                </div>
              );
            }
          },
        },
        {
          name: "使用时间",
          field: "usedTime",
          style: {
            width: 120,
            textAlign: "center",
          },
        },
      ];
    },
    onDownLoad() {
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_EXPORT,
        para: { bonusId: this.para.bonusId },
        isBlob: true,
        filename: "优惠券发放详情",
      })
        .then((res) => {})
        .catch(() => {});
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getBounsGiveList(this.para.bonusId);
    },
    onReset() {
      this.para.status = "";
      this.para.pageCurrent = 1;
      this.para.pageSize = 15;
      this.getBounsGiveList(this.para.bonusId);
    },
    getBounsGiveList(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_BONUS_GIVE_PAGE,
        para: { status: this.para.status, bonusId: id, pageCurrent: this.para.pageCurrent, pageSize: 15 },
      }).then((res) => {
        this.dataList = res.pageList;
        this.total = res.total;
        this.isLoading = false;
      });
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getBounsGiveList(this.para.bonusId);
    },
  },
  created() {
    const { id } = this.$route.query;
    if (id) {
      this.getBounsGiveList(id);
      this.para.bonusId = id;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    this.dataList = [];
    this.total = 0;
    if (id) {
      this.getBounsGiveList(id);
      this.para.bonusId = id;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.used_style {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #52c41a;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.default_style {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.repire_style {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #ff4d4f;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
</style>
